<div class="mapContainer">
  <div id="{{target}}" class="map"></div>
  <app-map-toolbar-edit 
    [collapsible]="true" 
    [baseLayers]="itemTools" 
    (activate)="activateItem($event)" 
    [maxHeight]="200">
  </app-map-toolbar-edit>
  <div id="popup-zonas" class="ol-popup">
    <span id="popup-closer" class="ol-popup-closer" (click)="closePopUp()"></span>
    <div id="popup-zonas-content"></div>
  </div>
</div>